export interface Region {
  name: string;
  taskers: number;
  countries: number;
  medianAccept: string;
}

export const regions: Region[] = [
  { name: 'Latin America', taskers: 11400, countries: 20, medianAccept: '9 min' },
  { name: 'Southeast Asia', taskers: 9800, countries: 11, medianAccept: '11 min' },
  { name: 'Africa', taskers: 7200, countries: 38, medianAccept: '14 min' },
  { name: 'Europe', taskers: 6100, countries: 44, medianAccept: '12 min' },
  { name: 'Middle East & South Asia', taskers: 4300, countries: 19, medianAccept: '16 min' },
];
